import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./components/Login";
import Profile from "./components/Profile";
import Header from "./components/Header";
import AddShift from "./components/AddShift";
import AddTemplateShift from "./components/AddTemplateShift";
import ScheduleChk from "./components/ScheduleChk";
import ComboAdmin from "./components/ComboAdmin";
import RecordCombo from "./components/RecordCombo";
import NotFound from "./components/NotFound";
import Admin from "./components/Admin";
import ChangeYourPassword from "./components/ChangeYourPassword";
import ScheduleMNG from "./components/ScheduleMNG";
import EditCombo from "./components/EditCombo";
import CreateCombo from "./components/CreateCombo";
import Reports from "./components/Reports";
import ReportFood from "./components/reports/ReportFood";
import TO from "./components/TO";
import Users from "./components/Users";
import Employee from "./components/reports/Employee";
import ServiceNotesReport from "./components/reports/ServiceNotesReport";
import ServiceNoteDetail from "./components/reports/ServiceNoteDetail";
import ApproveMNG from "./components/reports/ApproveMNG";
import ApproveCHK from "./components/reports/ApproveCHK";
import CheckDep from "./components/CheckDep";
import AutoDep from "./components/AutoDep";
import ReportFT from "./components/reports/ReportFT";
import ReportEnergy from "./components/reports/ReportEnergy";
import ReportDeploymentAccuracy from "./components/reports/ReportDeploymentAccuracy";
import ReportPayroll from "./components/reports/ReportPayroll";
import ReportShifts from "./components/reports/ReportShifts";
import GetScheduleMNGOnlyDirectus from "./components/reports/ScheduleMNGOnlyDirects";

// reports

import Motivation from "./components/tableReports/Motivation";
import MotivationMNG from "./components/tableReports/MotivationMNG";

const App = () => {
  const [token, setToken] = useState(localStorage.getItem("token") || "");
  const [userAccessLevel, setUserAccessLevel] = useState(
    localStorage.getItem("access_level") || "",
  );

  const handleLogin = (newToken, access_level) => {
    localStorage.setItem("token", newToken);
    localStorage.setItem("access_level", access_level);
    setToken(newToken);
    setUserAccessLevel(access_level);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken("");
  };

  const ProtectedRoute = ({ children, requiredLevel }) => {
    if (!token) return <Navigate to="/" replace />;
    if (Number(requiredLevel) > Number(localStorage.getItem("access_level"))) {
      return <Navigate to="/404" replace />;
    }
    return children;
  };

  const ProtectedRouteOnlyCHK = ({ children, requiredLevel }) => {
    if (!token) return <Navigate to="/" replace />;
    if (
      Number(requiredLevel) !=
      Number(userAccessLevel ?? localStorage.getItem("access_level"))
    ) {
      return <Navigate to="/404" replace />;
    }
    return children;
  };

  const ProtectedRouteWithoutTYHR = ({ children, requiredLevel }) => {
    if (!token) return <Navigate to="/" replace />;
    if (
      Number(requiredLevel) <=
      Number(userAccessLevel ?? localStorage.getItem("access_level"))
    ) {
      return <Navigate to="/404" replace />;
    }
    return children;
  };

  return (
    <Router>
      <Header
        isAuthenticated={!!token}
        userAccessLevel={
          userAccessLevel ?? localStorage.getItem("access_level")
        }
        token={token}
        onLogout={handleLogout}
      />

      <main>
        <Routes>
          <Route
            path="/"
            element={
              token ? (
                <Navigate to="/profile" />
              ) : (
                <Login onLogin={handleLogin} />
              )
            }
          />
          <Route
            path="/profile"
            element={
              token ? (
                <Profile
                  token={token}
                  onLogout={handleLogout}
                  userAccessLevel={localStorage.getItem("access_level")}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/add-shift"
            element={
              <ProtectedRouteOnlyCHK requiredLevel="1">
                <AddShift token={token} />
              </ProtectedRouteOnlyCHK>
            }
          />
          <Route
            path="/loading-template-shift"
            element={
              <ProtectedRoute requiredLevel="20">
                <AddTemplateShift
                  token={token}
                  userAccessLevel={localStorage.getItem("access_level")}
                />
              </ProtectedRoute>
            }
          />
          {/* <Route path="/loading-template-shift" element={
            token ? <AddTemplateShift token={token} onLogout={handleLogout} userAccessLevel={localStorage.getItem('access_level')}/> : <Navigate to="/" />
          } /> */}
          <Route
            path="/schedule-chk"
            element={
              <ProtectedRoute requiredLevel="10">
                <ScheduleChk token={token} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/schedule-mng"
            element={
              <ProtectedRoute requiredLevel="10">
                <ScheduleMNG token={token} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/change-your-password"
            element={
              <ProtectedRoute requiredLevel="1">
                <ChangeYourPassword token={token} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pdr!@"
            element={
              <ProtectedRoute requiredLevel="100">
                <Admin token={token} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/combo"
            element={
              token ? (
                <ComboAdmin
                  token={token}
                  onLogout={handleLogout}
                  userAccessLevel={localStorage.getItem("access_level")}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/create-combo"
            element={
              token ? (
                <CreateCombo
                  token={token}
                  onLogout={handleLogout}
                  userAccessLevel={localStorage.getItem("access_level")}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />

          <Route
            path="/check_dep"
            element={
              <ProtectedRoute requiredLevel="10">
                <CheckDep token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/record-food"
            element={
              <ProtectedRouteWithoutTYHR requiredLevel="20">
                <RecordCombo token={token} />
              </ProtectedRouteWithoutTYHR>
            }
          />

          <Route
            path="/reports"
            element={
              <ProtectedRoute requiredLevel="10">
                <Reports token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-food"
            element={
              <ProtectedRoute requiredLevel="10">
                <ReportFood token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-FT"
            element={
              <ProtectedRoute requiredLevel="10">
                <ReportFT token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-deployment-accuracy"
            element={
              <ProtectedRoute requiredLevel="12">
                <ReportDeploymentAccuracy token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-payroll"
            element={
              <ProtectedRoute requiredLevel="40">
                <ReportPayroll token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-energy"
            element={
              <ProtectedRoute requiredLevel="20">
                <ReportEnergy token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-employee"
            element={
              <ProtectedRoute requiredLevel="11">
                <Employee token={token} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/report-service-notes/:id"
            element={
              <ProtectedRoute requiredLevel="20">
                <ServiceNoteDetail token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-service-notes"
            element={
              <ProtectedRoute requiredLevel="20">
                <ServiceNotesReport token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-approve-mng"
            element={
              <ProtectedRoute requiredLevel="12">
                <ApproveMNG token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-approve-chk"
            element={
              <ProtectedRoute requiredLevel="12">
                <ApproveCHK token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-shifts"
            element={
              <ProtectedRoute requiredLevel="11">
                <ReportShifts token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/report-nmg-shedule-only-directors"
            element={
              <ProtectedRoute requiredLevel="20">
                <GetScheduleMNGOnlyDirectus token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/TO"
            element={
              <ProtectedRoute requiredLevel="10">
                <TO token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/users-edit"
            element={
              <ProtectedRoute requiredLevel="20">
                <Users token={token} />
              </ProtectedRoute>
            }
          />

          <Route
            path="/auto-dep"
            element={
              <ProtectedRoute requiredLevel="12">
                <AutoDep token={token} accessLevel={userAccessLevel} />
              </ProtectedRoute>
            }
          />

          {/* <Route path="/record-food" element={
            token ? <RecordCombo token={token} onLogout={handleLogout} userAccessLevel={localStorage.getItem('access_level')}/> : <Navigate to="/" />
          } /> */}

          {/* tableReports */}
          <Route
            path="/reports-motivation"
            element={
              <ProtectedRoute requiredLevel="12">
                <Motivation token={token} accessLevel={userAccessLevel} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports-motivationMNG"
            element={
              <ProtectedRoute requiredLevel="12">
                <MotivationMNG token={token} accessLevel={userAccessLevel} />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </Router>
  );
};

export default App;
